import { Typography } from "@mui/material";
import React from "react";
import { Styled } from "../styles";
import { shorten } from "@/utils/helpers";
import { useTransfer } from "./hooks";
import storage from "@/utils/storage";
import { useModal } from "@/components/product/table/modal/context";
import useQueryBrands from "@/hooks/queries/useQueryBrands";

const BrandsModal: React.FC = () => {
    const product = useModal(state => state.product);
    const pid = product?.pid;

    const { data: brands } = useQueryBrands();
    const bid = storage.getItem("bid");

    const onTransfer = useTransfer();

    return (
        <Styled.Body data-testid="brands-list-modal">
            <Styled.BrandList>
                {(brands?.filter(i => i._id !== bid) ?? []).map((brand, index) => {
                    const { _id: bid, media, title } = brand;
                    const url: string | undefined = media && media.variants?.[4]?.url;
                    return (
                        <Styled.BrandListItem
                            key={bid}
                            onClick={() => (pid ? onTransfer(pid, bid) : null)}
                            data-testid={`brands-list-${index}`}
                        >
                            {url ? (
                                <Styled.BrandLogo src={url} alt={title} />
                            ) : (
                                <Styled.BrandLogoPlaceholder>
                                    <Typography sx={{ textTransform: "uppercase" }}>
                                        {title[0]}
                                    </Typography>
                                </Styled.BrandLogoPlaceholder>
                            )}
                            <Typography variant="caption" textAlign="center">
                                {shorten(title, 35)}
                            </Typography>
                        </Styled.BrandListItem>
                    );
                })}
            </Styled.BrandList>
        </Styled.Body>
    );
};

export default BrandsModal;
